@if (isModal) {
  <button (click)="close.emit()" class="close-btn">&times;</button>
}

<div class="template-content">
  <div class="head">
    <h1 class="title">
      PREMIUM <br />
      ACCESS
    </h1>

    <div class="features">
      <div class="feature">
        <div class="icon">
          <svg
            viewBox="0 0 8 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.39679 6.54972C5.39679 6.54972 5.22405 5.90156 5.28146 5.42109C5.32008 5.09837 5.30421 5.03687 5.39628 4.91115C5.39628 4.91115 5.39697 4.91035 5.39731 4.90987C5.41248 4.88937 5.43041 4.86711 5.45196 4.84148C5.86003 4.31377 6.07035 3.72807 6.21258 3.19827C6.27964 2.89445 6.24706 2.31933 6.24706 2.31933L6.40704 2.43128C6.41566 2.47516 6.43101 2.51168 6.44807 2.54099C6.46221 2.58119 6.47893 2.63068 6.49583 2.68609C6.54341 2.93561 6.54255 3.37284 6.25326 4.01908C6.23482 4.05687 6.2162 4.09595 6.19758 4.13615C6.10742 4.32193 6.01605 4.5343 5.9376 4.76429C5.89692 4.87111 5.85968 4.98274 5.82744 5.09821C5.759 5.32964 5.71556 5.54185 5.71728 5.69768C5.71728 5.69768 5.71728 5.698 5.71728 5.69816C5.70435 5.85223 5.70314 6.00999 5.71728 6.17031C5.729 6.42832 5.78624 6.69642 5.90812 6.96853C6.00243 7.18858 6.23878 7.33833 6.41946 7.54061C6.41946 7.54061 6.32481 7.3513 6.2643 6.98006C6.24964 6.5731 6.24258 5.97507 6.90838 5.251C8.36755 3.66481 8.70683 0.7578 5.75297 1.01005C5.21733 0.524131 4.37223 0.0897848 3.04511 0.0108274C-0.203725 -0.182642 0.532069 2.28073 0.532069 2.28073C0.365533 2.99007 0.448801 3.22326 0.448801 3.22326L0.573789 3.42858C0.435009 3.58329 0.2683 3.44155 0.2683 3.44155C0.365533 3.60923 0.601545 3.57048 0.601545 3.57048C0.504313 3.91866 0.0600438 4.33138 0.00453169 4.48625C-0.0509804 4.64097 0.421045 4.75708 0.462765 4.84741C0.504486 4.93774 0.323985 5.13121 0.323985 5.13121C0.323985 5.13121 0.212961 5.22154 0.460696 5.35046C0.708432 5.47939 0.559998 5.4536 0.559998 5.4536C0.379497 5.69864 0.671022 5.69864 0.671022 5.69864C0.671022 5.69864 0.768254 5.72443 0.740498 5.93728C0.712742 6.15013 0.823766 6.35641 0.823766 6.35641C1.25631 6.67784 2.76755 6.0843 3.1139 5.94208C3.14114 6.09471 3.25751 6.2467 3.27906 6.44065C3.39698 7.24656 3.1139 7.58866 3.1139 7.58866C3.10287 7.66393 3.05408 7.70429 2.31949 7.9221C2.28311 7.93331 2.24622 7.94452 2.20881 7.95574C1.3463 8.22432 0.487935 8.78038 0.373808 9.40724C0.237096 10.1587 0.149518 10.5176 0.0924546 11H8C7.64348 8.74179 6.49359 8.10965 6.0326 7.7738C6.0326 7.7738 5.59195 7.52459 5.39696 6.54988L5.39679 6.54972Z"
              fill="white"
            />
          </svg>
        </div>
        Create your own Girlfriend
      </div>
      <div class="feature">
        <div class="icon">
          <svg
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.746 6.6527H12.6343L11.4768 3.26667L1.54222 6.6527L1.31746 6.65079M1 6.65333H1.31746L8.39429 1L10.1829 3.50794"
              stroke="white"
              stroke-linecap="square"
            />
            <path
              d="M8.61992 9.82534C8.61992 10.2463 8.45268 10.6501 8.15501 10.9477C7.85733 11.2454 7.45359 11.4126 7.03261 11.4126C6.61164 11.4126 6.2079 11.2454 5.91022 10.9477C5.61255 10.6501 5.44531 10.2463 5.44531 9.82534C5.44531 9.40436 5.61255 9.00062 5.91022 8.70295C6.2079 8.40527 6.61164 8.23804 7.03261 8.23804C7.45359 8.23804 7.85733 8.40527 8.15501 8.70295C8.45268 9.00062 8.61992 9.40436 8.61992 9.82534Z"
              stroke="white"
              stroke-linecap="square"
            />
            <path
              d="M13.0635 6.65063V12.9998H1V6.65063H13.0635Z"
              stroke="white"
              stroke-linecap="square"
            />
            <path
              d="M1 6.65063H2.26984C2.26984 6.98742 2.13605 7.31041 1.89791 7.54855C1.65977 7.78669 1.33678 7.92048 1 7.92048V6.65063ZM13.0635 6.65063H11.7937C11.7937 6.98742 11.9274 7.31041 12.1656 7.54855C12.4037 7.78669 12.7267 7.92048 13.0635 7.92048V6.65063ZM1 12.9998H2.27111C2.27128 12.8329 2.23851 12.6675 2.17469 12.5132C2.11087 12.3589 2.01725 12.2187 1.89918 12.1007C1.78112 11.9826 1.64092 11.889 1.48663 11.8251C1.33234 11.7613 1.16697 11.7286 1 11.7287V12.9998ZM13.0635 12.9998H11.7937C11.7937 12.6631 11.9274 12.3401 12.1656 12.1019C12.4037 11.8638 12.7267 11.73 13.0635 11.73V12.9998Z"
              stroke="white"
              stroke-linecap="square"
            />
          </svg>
        </div>
        1000 FREE tokens daily
      </div>
      <div class="feature">
        <div class="icon">
          <svg
            viewBox="0 0 10 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.04995 6.37796C8.8857 6.14462 8.68574 5.94239 8.50006 5.74016C8.02157 5.27348 7.47881 4.93903 7.02175 4.44902C5.95766 3.31343 5.72199 1.43893 6.40044 0C5.72199 0.178894 5.12924 0.58335 4.62219 1.0267C2.77253 2.64452 2.04409 5.49905 2.91536 7.94912C2.94393 8.0269 2.9725 8.10468 2.9725 8.20579C2.9725 8.37691 2.86537 8.53247 2.72254 8.59469C2.55829 8.67247 2.38689 8.6258 2.2512 8.50135C2.21067 8.46437 2.17677 8.41954 2.15122 8.36913C1.34422 7.25687 1.21567 5.66238 1.75843 4.38679C0.565794 5.4446 -0.0840869 7.23354 0.00875321 8.92137C0.0516025 9.31027 0.0944518 9.69917 0.215858 10.0881C0.31584 10.5547 0.508662 11.0214 0.722908 11.4337C1.4942 12.7793 2.82967 13.7437 4.26512 13.9382C5.79341 14.1482 7.42882 13.8448 8.60004 12.6937C9.90694 11.4025 10.364 9.3336 9.69269 7.56022L9.59985 7.35799C9.44988 7.0002 9.04995 6.37796 9.04995 6.37796ZM6.79323 11.2781C6.59326 11.4648 6.26475 11.667 6.00765 11.7448C5.2078 12.0559 4.40795 11.6203 3.93661 11.107C4.78645 10.8892 5.2935 10.2047 5.44347 9.51249C5.56488 8.89025 5.33635 8.37691 5.24351 7.778C5.15781 7.20243 5.17209 6.71241 5.36492 6.17573C5.5006 6.4713 5.64344 6.76686 5.81483 7.0002C6.36473 7.778 7.22886 8.12023 7.41454 9.17804C7.44311 9.28693 7.45739 9.39582 7.45739 9.51249C7.47881 10.1503 7.22172 10.8503 6.79323 11.2781Z"
              fill="white"
            />
          </svg>
        </div>
        Hot role-play chatting
      </div>
      <div class="feature">
        <div class="icon">
          <svg
            viewBox="0 0 16 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 0C10.3248 0 9.11121 1.2536 7.99921 2.6768C6.88721 1.2536 5.67441 0 4.00001 0C1.79441 0 1.19592e-05 1.7944 1.19592e-05 4C-0.00127412 4.5249 0.10118 5.04488 0.301487 5.53007C0.501793 6.01525 0.796004 6.45607 1.16721 6.82719C1.53706 7.19984 1.97718 7.49538 2.46207 7.6967C2.94696 7.89802 3.46699 8.00111 3.99201 7.99999H4.00161C5.67281 7.99599 6.88561 6.74239 7.99841 5.31919C9.11121 6.74479 10.3248 7.99999 12 7.99999C14.2056 7.99999 16 6.20559 16 4C16 1.7944 14.2056 0 12 0ZM3.99841 6.39999L3.99201 7.19999V6.39999C3.35281 6.39999 2.75201 6.15039 2.30081 5.69759C1.96641 5.36125 1.739 4.93348 1.64724 4.46816C1.55547 4.00283 1.60345 3.52075 1.78513 3.08264C1.96681 2.64453 2.27406 2.26997 2.6682 2.00613C3.06233 1.7423 3.52572 1.60099 4.00001 1.6C5.06401 1.6 6.04801 2.7504 6.99681 3.9984C6.04641 5.24559 5.06241 6.39759 3.99841 6.39999ZM12 6.39999C10.936 6.39999 9.95121 5.24799 9.00081 3.9984C9.95041 2.7504 10.9344 1.6 12 1.6C13.3232 1.6 14.4 2.6768 14.4 4C14.4 5.32319 13.3232 6.39999 12 6.39999Z"
              fill="white"
            />
          </svg>
        </div>
        Unlimited hot photos
      </div>
    </div>
  </div>

  <div class="spacer"></div>
  <div class="spacer"></div>

  <div class="subscriptions">
    @for (subscription of subscriptions; track subscription.id) {
      <div
        class="subscription"
        [class.selected]="selectedSubscription === subscription"
        (click)="selectSubscription(subscription)"
      >
        <div class="sub-content">
          @if (selectedSubscription !== subscription) {
            <svg
              class="check"
              viewBox="0 0 16 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="7.87147" cy="7.25075" r="6.74159" stroke="#7F7FA2" />
            </svg>
          } @else {
            <svg
              class="check"
              viewBox="0 0 16 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="7.87147"
                cy="7.25075"
                r="6.49159"
                stroke="url(#paint0_linear_1494_7845)"
                stroke-width="1.5"
              />
              <foreignObject
                x="-76.6543"
                y="-77.2753"
                width="169.052"
                height="169.052"
              >
                <div
                  xmlns="http://www.w3.org/1999/xhtml"
                  style="
                    backdrop-filter: blur(40px);
                    clip-path: url(#bgblur_0_1494_7845_clip_path);
                    height: 100%;
                    width: 100%;
                  "
                ></div>
              </foreignObject>
              <circle
                data-figma-bg-blur-radius="80"
                cx="7.8717"
                cy="7.25073"
                r="4.52599"
                fill="url(#paint1_linear_1494_7845)"
              />
              <defs>
                <clipPath
                  id="bgblur_0_1494_7845_clip_path"
                  transform="translate(76.6543 77.2753)"
                >
                  <circle cx="7.8717" cy="7.25073" r="4.52599" />
                </clipPath>
                <linearGradient
                  id="paint0_linear_1494_7845"
                  x1="7.87147"
                  y1="0.00915527"
                  x2="7.87147"
                  y2="14.4923"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FC46A4" />
                  <stop offset="1" stop-color="#DA2FF5" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_1494_7845"
                  x1="7.8717"
                  y1="2.72473"
                  x2="7.8717"
                  y2="11.7767"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FC46A4" />
                  <stop offset="1" stop-color="#DA2FF5" />
                </linearGradient>
              </defs>
            </svg>
          }

          <div>
            <div class="period">
              @switch (subscription.type) {
                @case (offerType.yearlySubscription) {
                  Yearly
                }
                @case (offerType.weeklySubscription) {
                  Weekly
                }
                @case (offerType.monthlySubscription) {
                  Monthly
                }
              }
            </div>
            <div class="tokens-bonus">
              @switch (subscription.type) {
                @case (offerType.yearlySubscription) {
                  5000
                }
                @case (offerType.weeklySubscription) {
                  500
                }
                @case (offerType.monthlySubscription) {
                  1200
                }
              }
              tokens <span>right now!</span>
            </div>
          </div>
          <div class="spacer"></div>
          <div class="price-wrapper">
            @if (environment.buildVersion !== buildVersion.nutaku) {
              <span class="old-price">
                @switch (subscription.type) {
                  @case (offerType.yearlySubscription) {
                    $49,99
                  }
                  @case (offerType.weeklySubscription) {
                    $9,99
                  }
                  @case (offerType.monthlySubscription) {
                    $19,99
                  }
                }</span
              ><br />
            }

            <app-premium-button-text
              [offerData]="subscription"
              fullTemplate="{cost} <br/> then {nextCost}"
              shortTemplate="{cost}"
              class="price"
            ></app-premium-button-text>

            @if (subscription.type === offerType.yearlySubscription) {
              <div class="best-label">
                <svg
                  viewBox="0 0 54 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.17111 2.90112C2.66174 1.18391 4.23128 0 6.01721 0H49.6971C52.3546 0 54.2733 2.54362 53.5432 5.09888L51.8289 11.0989C51.3383 12.8161 49.7687 14 47.9828 14H4.30292C1.64541 14 -0.273252 11.4564 0.456824 8.90112L2.17111 2.90112Z"
                    fill="url(#paint0_linear_2114_10614)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_2114_10614"
                      x1="27"
                      y1="0"
                      x2="27"
                      y2="14"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FC46A4" />
                      <stop offset="1" stop-color="#DA2FF5" />
                    </linearGradient>
                  </defs>
                </svg>

                <span>BEST</span>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>

  <div class="spacer"></div>

  <button class="subscribe-btn" (click)="purchase()">
    Subscribe

    <svg viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.02921 7.071L2.51655 12.728L0.888672 11.314L6.5874 6.364L0.888672 1.414L2.51655 0L9.02921 5.657C9.24504 5.84453 9.36629 6.09884 9.36629 6.364C9.36629 6.62916 9.24504 6.88347 9.02921 7.071Z"
        fill="white"
      />
    </svg>
  </button>

  <app-premium-description-text
    [offerData]="selectedSubscription"
    class="subscription-info"
  >
  </app-premium-description-text>

  @if (
    environment.buildVersion === buildVersion.legal ||
    environment.mode === "test"
  ) {
    <div class="paywall-policies">
      <a
        (click)="openTerms.emit()"
        [innerHTML]="'SETTINGS_PAGE.TERMS_OF_USE' | translate"
      ></a>
      <a
        (click)="openPolicy.emit()"
        [innerHTML]="'SETTINGS_PAGE.PRIVACY' | translate"
      ></a>
    </div>
  }
</div>
